<template>
  <div class="date-navigator">
    <CalendarDropdown @update:single="handleDateSelection" />
    <button class="button-chevron" @click="handlePrevDay">
      <img class="chevron-icon" src="../../assets/icons/chevron-left.svg" />
    </button>
    <div @click="handlePrevDay">
      <DayCard :date="selectedDatePrev" prev />
    </div>
    <div @click="() => handleDateSelection(selectedDate)">
      <DayCard :date="selectedDate" />
    </div>
    <div @click="handleNextDay">
      <DayCard :date="selectedDateNext" next />
    </div>
    <button class="button-chevron" @click="handleNextDay">
      <img class="chevron-icon" src="../../assets/icons/chevron-right.svg" />
    </button>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import moment from 'moment';
import CalendarDropdown from './CalendarDropdown.vue';
import DayCard from './DayCard.vue';

const PHOENIX_OFFSET = -7; // Phoenix is UTC-7 (MST)

const emit = defineEmits(['dateChanged']);

const selectedDate = ref(moment().utcOffset(PHOENIX_OFFSET));

const selectedDatePrev = computed(() => {
  return moment(selectedDate.value).subtract(1, 'day');
});

const selectedDateNext = computed(() => {
  return moment(selectedDate.value).add(1, 'day');
});

function handleDateSelection(date) {
  selectedDate.value = moment(date).utcOffset(PHOENIX_OFFSET);
  emit('dateChanged', selectedDate.value);
}

function handlePrevDay() {
  selectedDate.value = moment(selectedDate.value).subtract(1, 'day').utcOffset(PHOENIX_OFFSET);
  emit('dateChanged', selectedDate.value);
}

function handleNextDay() {
  selectedDate.value = moment(selectedDate.value).add(1, 'day').utcOffset(PHOENIX_OFFSET);
  emit('dateChanged', selectedDate.value);
}
</script>

<style scoped>
.date-navigator {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.date-navigator > div {
  cursor: pointer;
}

.chevron-icon {
  width: 30px;
  height: 30px;
}

.button-chevron {
  margin: 8px;
}
</style>
